import React, { useState } from 'react';
import { useSession } from '@/auth/index';
import { useAppConfigContext } from '@/context/AppConfig';
import { useAppConstantsContext } from '@/context/AppConstants';
import { SearchTabData } from '@/reports/index';
import { Box, Icons } from '@/theme/index';
import { useScreenSize } from '@/utils/index';
import { HeaderMenu } from './HeaderMenu/HeaderMenu';
import { CustomSearchTab } from './SearchTab/CustomSearchTab';
import { HeaderNav, TabText } from './components';
import { HeaderNavItem } from '../../components';

interface HeaderSearchProps {
  selectedTab: SearchTabData | null;
  setSelectedTab: (tab: SearchTabData) => void;
}

export function NavigationHeader({
  setSelectedTab,
  selectedTab,
}: HeaderSearchProps) {
  const {
    config: { headerTabs },
  } = useAppConstantsContext();
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(menuAnchorEl);
  const { isMobile, isMedium } = useScreenSize();
  const { navigate } = useAppConfigContext().routingUtils;

  const handleMenuClick = (event: React.MouseEvent<HTMLLIElement>) => {
    setMenuAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
  };
  const handleSearchClick = (event: React.MouseEvent<HTMLLIElement>) => {
    event.preventDefault();
    navigate((headerTabs && headerTabs[0].route) || '');
  };
  const {
    session: { account },
  } = useSession();
  const isNonCompliant = account?.account.user_info.noncompliant;

  return (
    <>
      {!isNonCompliant && headerTabs && (
        <Box display="flex" justifyContent="center" alignItems="center">
          <HeaderNav className="side-nav">
            {headerTabs.length > 0 && (
              <>
                {headerTabs.map((tab) => (
                  <CustomSearchTab
                    tab={tab}
                    setSelectedTab={setSelectedTab}
                    key={tab.id}
                    selectedTab={selectedTab}
                  />
                ))}
              </>
            )}
          </HeaderNav>
          <HeaderNav className="side-nav">
            {(isMobile || isMedium) && (
              <HeaderNavItem
                className="custom-menu"
                onClick={handleSearchClick}
                data-cy="header-menu-toggle"
              >
                <Icons.Search />
              </HeaderNavItem>
            )}
            <HeaderNavItem
              className="custom-menu"
              onClick={handleMenuClick}
              data-cy="header-menu-toggle"
            >
              <TabText>Menu</TabText>
              {open ? <Icons.Close /> : <Icons.ExpandCircleDown />}
            </HeaderNavItem>
          </HeaderNav>
        </Box>
      )}
      <HeaderMenu
        anchorEl={menuAnchorEl}
        open={open}
        handleClose={handleCloseMenu}
      />
    </>
  );
}
